import { render, staticRenderFns } from "./My_Bg.vue?vue&type=template&id=d97a4934&scoped=true"
import script from "./My_Bg.vue?vue&type=script&lang=js"
export * from "./My_Bg.vue?vue&type=script&lang=js"
import style0 from "./My_Bg.vue?vue&type=style&index=0&id=d97a4934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97a4934",
  null
  
)

export default component.exports